<template>
  <span>{{ bonus }}</span>
</template>

<script>
/**
 * @description Регулярное выражение для форматирования чисел с разделением тысяч пробелами.
 * @type {RegExp}
 */
const defaultRegex = /\B(?=(\d{3})+(?!\d))/g;

export default {
  /**
   * @description Компонент бонуса
   */
  name: 'TheBonus',
  computed: {
    bonus() {
      const formattedBonuses = this.bonuses
        .toString()
        .replace(this.regex, ' ');
      return `${formattedBonuses} ${this.postfix}`;
    },
  },
  props: {
    /**
     * @description Постфикс для бонусов.
     * @type {String}
     */
    postfix: {
      type: String,
      required: false,
      default: 'Б',
    },
    /**
     * @description Бонусы.
     * @type {Number}
     */
    bonuses: {
      type: Number,
      required: true,
    },
    /**
     * @description Регулярное выражение для форматирования
     * @type {RegExp}
     */
    regex: {
      type: RegExp,
      default: () => defaultRegex,
    },
  },
};
</script>
